export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/ao.5358ad4f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};